import { STEPS } from "./Steps";
import { CARD_TYPES } from "./CardTypes";

export const TOOLTIP_DISABLED_DIGITAL_BUTTON = 'Your guest list is missing some information. Please make sure all recipients have email addresses';
export const TOOLTIP_DISABLED_SEND_CARDS = 'Your guest list is missing some information. Please make sure at least one recipient is selected and all required recipients information is provided';
export const TOOLTIP_DISABLED_MISSING_RECIPIENTS = 'Please select at least one recipient.';
export const TOOLTIP_DISABLED_CONTENT_TOO_LARGE = 'Your content is too large for the box shown in red. Please increase box size or reduce font size to proceed';

export const CARD_TYPES_SINGULAR = {
  [CARD_TYPES.invitation]: 'Invitation',
  [CARD_TYPES.invitationEnvelope]: 'Invitation Envelope',
  [CARD_TYPES.std]: 'Save The Date',
  [CARD_TYPES.ctd]: 'Change The Date',
  [CARD_TYPES.thankyou]: 'Thank You',
  [CARD_TYPES.menu]: 'Menu',
  [CARD_TYPES.program]: 'Program',
  [CARD_TYPES.holiday]: 'Holiday',
  [CARD_TYPES.enclosure]: 'Enclosure',
  [CARD_TYPES.rsvp]: 'RSVP',
  [CARD_TYPES.rsvpEnvelope]: 'RSVP Envelope',
};

export const CUSTOMIZATION_BAR_SUBTOTAL_DROPDOWN = {
  [STEPS.detailFront]: {
    label: 'FRONT',
    description: 'Print on the front (required)',
  },
  [STEPS.detailInside]: {
    label: 'INSIDE',
    description: 'Print on the inside',
  },
  [STEPS.detailBack]: {
    label: 'BACK',
    description: 'Print on the back',
  },
  [STEPS.recipients]: {
    label: 'GUESTS',
    description: 'Add guest addressing',
  },
  [STEPS.envelope]: {
    label: 'ENVELOPE',
    description: 'Print your return address',
  },
  [STEPS.rsvp]: {
    label: 'RSVP CARD',
    description: 'Add RSVP cards & envelopes',
  },
  [STEPS.rsvpEnvelope]: {
    label: 'RSVP ENVELOPE',
    description: 'Print mailing address',
  }
};


// WEBPACK FOOTER //
// ./src/cards/constants/Copy.js